// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-bubble-wrapper {
  position: relative;
  display: inline-block;
  text-align: left;
  max-width: 75%;
  width: fit-content;
}

.message-bubble {
  position: relative;
  text-align: left;
  font-size: 14px;
  line-height: 17px;
  padding: 8px 16px;
  font-family: Roboto, Arial, sans-serif;
  background-color: rgb(242, 242, 242);
  color: rgb(33, 33, 33);
  border-radius: 17px 17px 17px 3px;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: inherit;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  float: left;
  clear: both;
  min-width: 40px;
}

.message-bubble.user {
  background-color: var(--netsfere-red);
  color: white;
  border-radius: 17px 17px 3px 17px;
  float: left;
  clear: both;
}

/* Extra space only when reactions are present */
.message-bubble.has-reactions {
  margin-bottom: 24px;
}

.message-bubble.user.has-reactions {
  margin-bottom: 24px;
}

/* Position-based border radius for user messages */
.message-bubble.user.first {
  border-radius: 17px 17px 3px 17px; /* Only bottom-right is small */
}

.message-bubble.user.continuation {
  border-radius: 17px 3px 3px 17px; /* Both top-right and bottom-right are small */
}

/* Position-based border radius for other user messages */
.message-bubble.first {
  border-radius: 17px 17px 17px 3px; /* Only bottom-left is small */
}

.message-bubble.continuation {
  border-radius: 3px 17px 17px 3px; /* Both top-left and bottom-left are small */
}

.message-bubble span.deleted-message {
  font-style: italic;
  opacity: 0.7;
}

.message-bubble span.deleted-message.clickable {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.message-bubble span.deleted-message.clickable:hover {
  opacity: 1;
}

.message-bubble.highlighted {
  background-color: #666 !important;
  color: white !important;
}

/* Highlight entire message row for EDITS only */
.message-item.edit-highlighted {
  position: relative;
  background: rgba(204, 204, 204, 0.3);
  border-radius: 12px;
  border: 2px solid #999;
  margin: 4px 0px 4px 4px;
  padding: 4px;
  max-width: calc(100% - 8px);
  box-sizing: border-box;
}

.message-item.edit-highlighted .message-bubble {
  background-color: #666 !important;
  color: white !important;
  position: relative;
  z-index: 1;
}

.message-item.edit-highlighted .message-reply-preview {
  background-color: #555 !important;
}

.message-item.selected .message-bubble {
  background-color: rgb(71, 71, 71) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;
}

/* Animation for flashing a message */
@keyframes flash-background {
  0% { background-color: #cccccc; }
  100% { background-color: transparent; }
}

.message-item--flashed {
  animation: flash-background 1.5s ease-out;
}


.message-item.selected .message-reply-preview {
  background-color: rgba(0, 0, 0, 0.3) !important;
}


.message-bubble-hover-menu {
  border: 1px solid #d9d9d9;
  position: absolute;
  display: flex;
  justify-content: flex-start; /* Align items to the left */
  align-items: center;
  gap: 8px; /* Add space between kebab and emoji */
  top: 0px;
  width: 50px; /* Extended from 25px to accommodate reaction button */
  height: 20px;
  background: white;
  border-radius: 20px;
  margin: 3px 5px;
  padding: 2px 4px; /* Minimal padding - less on left, small on right */
  right: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}


.message-bubble-hover-menu.user {
  left: 0;
  right: unset;
  left: unset;
}

.message-bubble-context-menu-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}

.message-bubble-context-menu-wrapper, .message-bubble-reaction-button {
  pointer-events: auto; /* Re-enable pointer events for buttons */
  position: relative;
}

/* Portal container for context menus - created dynamically and attached to .messages-list */
#message-context-menu-portal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Allow clicks through to messages */
  z-index: 1000;
  overflow: visible; /* Allow menu to extend beyond bounds */
}

.message-bubble-context-menu {
  /* Layout */
  padding: 0;
  width: 166px;
  
  /* Appearance */
  background-color: rgb(242, 242, 242);
  opacity: 1;
  box-shadow: rgb(0 0 0 / 4%) 0px 10px 20px, rgb(0 0 0 / 15%) 0px 6px 6px;
  border-radius: 7px;
  border: none;
  
  /* Typography */
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  
  /* Positioning: Menu is rendered in a portal container (#message-context-menu-portal) 
     that scrolls with the messages. Position is absolute (relative to portal container)
     with top/left coordinates set via inline styles. This ensures smooth scrolling
     without jitter and proper z-index layering. */
  position: absolute;
  pointer-events: auto; /* Re-enable pointer events (portal container has pointer-events: none) */
}

/* Legacy menu position classes removed - all positioning now handled by inline styles in portal */

.message-bubble-context-menu-item {
  padding: 10px 16px;
  display: flex;
  align-items: center;
}

.message-bubble-context-menu-item i {
  width: 14px;
  text-align: center;
  margin-right: 10px;
}

.message-bubble-context-menu-item.first {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}

.message-bubble-context-menu-item.last {
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
}

.message-bubble-context-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.message-bubble-context-menu-item-text {
  flex: 1;
}

.message-info {
  box-sizing: border-box;
  padding-top: 4px;
  font-size: 12px;
  line-height: 14px;
  height: 20px;
  font-family: Roboto, Arial, sans-serif;
  color: rgba(0, 0, 0, 0.5);
  overflow-wrap: break-word;
  word-break: break-word;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
}

.message-timestamp {
  display: inline-block;
  font-weight: bold;
  margin-right: 0.3em;
  vertical-align: middle;
}

.message-sender {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  color: var(--netsfere-red);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 280px;
}

.fa.fa-check-circle.read {
  color: var(--netsfere-red);
}

/* Message reply preview styles (inside message bubbles) */
.message-bubble .message-reply-preview {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  padding: 4px 8px;
  background-color: rgb(191, 40, 57);
  border-radius: 8px;
  border: none;
  max-width: 100%;
  text-align: left;
}

.message-bubble .message-reply-preview-content {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.message-bubble .message-reply-preview-sender {
  font-size: 11px;
  font-weight: bold;
  color: white !important;
  margin-bottom: 2px;
  line-height: 13px;
  text-align: left;
}

.message-bubble .message-reply-preview-text {
  font-size: 12px;
  line-height: 14px;
  color: rgba(255, 255, 255, 0.9) !important;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.message-reply-preview.attachment {
  gap: 8px;
}

.message-reply-preview-thumbnail {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
}

.message-reply-preview-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

/* Edit indicator styles */
.edit-indicator {
  font-size: 11px;
  font-style: italic;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 4px;
  user-select: none;
}

.message-bubble.user .edit-indicator {
  color: rgba(255, 255, 255, 0.8);
}

.edit-indicator.clickable {
  cursor: pointer;
}

.edit-indicator.clickable:hover {
  text-decoration: underline;
}

/* Reaction button styles */
.message-bubble-reaction-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.message-bubble-reaction-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.reaction-icon {
  width: 15px;
  height: 15px;
  filter: grayscale(100%);
  opacity: 0.7;
  user-select: none;
  object-fit: contain;
  margin-left: 1px; /* Add small left margin to prevent left side cutoff */
  margin-top: 1px; /* Add small top margin to lower the position slightly */
}

/* Emoji picker container for message reactions */
.message-bubble-emoji-picker-container {
  position: absolute;
  right: 0px;
  top: 5px;
  z-index: 1001; /* Higher than other overlays */
}

/* Attachment message styles */
.attachment-message {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attachment-message--file {
  cursor: pointer;
}

.attachment-file-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.attachment-file-text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.attachment-filename-inline {
  font-weight: 500;
  color: inherit;
}

.attachment-file-type-inline {
  font-size: 12px;
  opacity: 0.8;
}

.attachment-file-size-inline {
  font-size: 12px;
  opacity: 0.7;
}

/* Semantic button wrapper for attachment icon - accessible and keyboard navigable */
.attachment-icon-btn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-block;
  position: relative;
  line-height: 0; /* Remove extra spacing */
}

.attachment-icon-btn:disabled {
  cursor: default;
  opacity: 0.5;
}

.attachment-icon-btn:focus-visible {
  outline: 2px solid #007AFF;
  outline-offset: 2px;
  border-radius: 4px;
}

.attachment-icon {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  object-fit: contain;
}

/* New styles for image/video previews */
.attachment-preview-btn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: block;
  position: relative;
  line-height: 0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 4px;
}

.attachment-preview {
  max-width: 150px;
  max-height: 100px;
  width: 100%;
  display: block;
  object-fit: cover;
}

.attachment-preview-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 250px;
  height: 150px;
  background-color: #f0f0f0;
  color: #888;
  font-size: 12px;
  font-style: italic;
  text-align: center;
  padding: 10px;
  gap: 8px;
}

/* Make attachment icons white in user message bubbles */
.message-bubble.user .attachment-icon {
  filter: brightness(0) invert(1);
}

.attachment-info.preview-style {
  color: var(--netsfere-red);
  font-weight: 500;
  font-size: 13px;
}

/* Clickable elements styling */
.attachment-icon.clickable {
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.1s ease;
  border-radius: 4px;
}

.attachment-icon.clickable:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.attachment-icon.clickable:active {
  transform: scale(0.98);
}

.attachment-info.clickable {
  cursor: pointer;
  border-radius: 2px;
  padding: 1px 2px;
  margin: -1px -2px;
  transition: background-color 0.2s ease;
}

.attachment-info.clickable:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Hover effects for user messages */
.message-bubble.user .attachment-info.clickable:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.attachment-info {
  white-space: nowrap;
  color: rgb(222, 72, 88);
  line-height: 15px;
  font-size: 13px;
  text-decoration: none;
}

/* Attachment thumbnail styles */
.attachment-thumbnail {
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
  max-width: 200px;
}

.thumbnail-image {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.thumbnail-image:hover {
  opacity: 0.9;
}

/* Download Progress Styles */
.attachment-icon-wrapper {
  position: relative;
  width: 60px;
  height: 60px;
  flex-shrink: 0;
}

.download-progress-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

/* Cancel download button - WCAG AA compliant (44x44px minimum) */
.cancel-download-btn {
  position: absolute;
  top: 3px;
  right: 3px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  color: #333;
  font-weight: bold;
  transition: all 0.2s ease;
}

.cancel-download-btn:hover {
  background: white;
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.cancel-download-btn:active {
  transform: scale(0.98);
}

.cancel-download-btn:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: -2px;
}

.attachment-icon.downloading {
  opacity: 0.5;
  cursor: default;
}

.attachment-info.downloading {
  opacity: 0.7;
  cursor: default;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/MessageBubble.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;EACtC,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gDAAgD;EAChD,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iCAAiC;EACjC,WAAW;EACX,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,iCAAiC,EAAE,+BAA+B;AACpE;;AAEA;EACE,gCAAgC,EAAE,8CAA8C;AAClF;;AAEA,yDAAyD;AACzD;EACE,iCAAiC,EAAE,8BAA8B;AACnE;;AAEA;EACE,gCAAgC,EAAE,4CAA4C;AAChF;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,KAAK,yBAAyB,EAAE;EAChC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;;AAGA;EACE,+CAA+C;AACjD;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,2BAA2B,EAAE,4BAA4B;EACzD,mBAAmB;EACnB,QAAQ,EAAE,sCAAsC;EAChD,QAAQ;EACR,WAAW,EAAE,sDAAsD;EACnE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAE,mDAAmD;EACrE,QAAQ;EACR,UAAU;EACV,oCAAoC;AACtC;;;AAGA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,EAAE,yCAAyC;EAC/D,kBAAkB;AACpB;;AAEA,4FAA4F;AAC5F;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,qCAAqC;EAC3D,aAAa;EACb,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;;EAEZ,eAAe;EACf,oCAAoC;EACpC,UAAU;EACV,uEAAuE;EACvE,kBAAkB;EAClB,YAAY;;EAEZ,eAAe;EACf,sCAAsC;EACtC,eAAe;;EAEf;;;kDAGgD;EAChD,kBAAkB;EAClB,oBAAoB,EAAE,yEAAyE;AACjG;;AAEA,kGAAkG;;AAElG;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB,EAAE,sDAAsD;EACxE,eAAe,EAAE,wDAAwD;AAC3E;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa,EAAE,+BAA+B;AAChD;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,oFAAoF;AACpF;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA,wDAAwD;AACxD;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb","sourcesContent":[".message-bubble-wrapper {\n  position: relative;\n  display: inline-block;\n  text-align: left;\n  max-width: 75%;\n  width: fit-content;\n}\n\n.message-bubble {\n  position: relative;\n  text-align: left;\n  font-size: 14px;\n  line-height: 17px;\n  padding: 8px 16px;\n  font-family: Roboto, Arial, sans-serif;\n  background-color: rgb(242, 242, 242);\n  color: rgb(33, 33, 33);\n  border-radius: 17px 17px 17px 3px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: inherit;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  float: left;\n  clear: both;\n  min-width: 40px;\n}\n\n.message-bubble.user {\n  background-color: var(--netsfere-red);\n  color: white;\n  border-radius: 17px 17px 3px 17px;\n  float: left;\n  clear: both;\n}\n\n/* Extra space only when reactions are present */\n.message-bubble.has-reactions {\n  margin-bottom: 24px;\n}\n\n.message-bubble.user.has-reactions {\n  margin-bottom: 24px;\n}\n\n/* Position-based border radius for user messages */\n.message-bubble.user.first {\n  border-radius: 17px 17px 3px 17px; /* Only bottom-right is small */\n}\n\n.message-bubble.user.continuation {\n  border-radius: 17px 3px 3px 17px; /* Both top-right and bottom-right are small */\n}\n\n/* Position-based border radius for other user messages */\n.message-bubble.first {\n  border-radius: 17px 17px 17px 3px; /* Only bottom-left is small */\n}\n\n.message-bubble.continuation {\n  border-radius: 3px 17px 17px 3px; /* Both top-left and bottom-left are small */\n}\n\n.message-bubble span.deleted-message {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.message-bubble span.deleted-message.clickable {\n  cursor: pointer;\n  text-decoration: underline;\n  text-decoration-style: dotted;\n}\n\n.message-bubble span.deleted-message.clickable:hover {\n  opacity: 1;\n}\n\n.message-bubble.highlighted {\n  background-color: #666 !important;\n  color: white !important;\n}\n\n/* Highlight entire message row for EDITS only */\n.message-item.edit-highlighted {\n  position: relative;\n  background: rgba(204, 204, 204, 0.3);\n  border-radius: 12px;\n  border: 2px solid #999;\n  margin: 4px 0px 4px 4px;\n  padding: 4px;\n  max-width: calc(100% - 8px);\n  box-sizing: border-box;\n}\n\n.message-item.edit-highlighted .message-bubble {\n  background-color: #666 !important;\n  color: white !important;\n  position: relative;\n  z-index: 1;\n}\n\n.message-item.edit-highlighted .message-reply-preview {\n  background-color: #555 !important;\n}\n\n.message-item.selected .message-bubble {\n  background-color: rgb(71, 71, 71) !important;\n  color: white !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n  z-index: 1;\n}\n\n/* Animation for flashing a message */\n@keyframes flash-background {\n  0% { background-color: #cccccc; }\n  100% { background-color: transparent; }\n}\n\n.message-item--flashed {\n  animation: flash-background 1.5s ease-out;\n}\n\n\n.message-item.selected .message-reply-preview {\n  background-color: rgba(0, 0, 0, 0.3) !important;\n}\n\n\n.message-bubble-hover-menu {\n  border: 1px solid #d9d9d9;\n  position: absolute;\n  display: flex;\n  justify-content: flex-start; /* Align items to the left */\n  align-items: center;\n  gap: 8px; /* Add space between kebab and emoji */\n  top: 0px;\n  width: 50px; /* Extended from 25px to accommodate reaction button */\n  height: 20px;\n  background: white;\n  border-radius: 20px;\n  margin: 3px 5px;\n  padding: 2px 4px; /* Minimal padding - less on left, small on right */\n  right: 0;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n\n.message-bubble-hover-menu.user {\n  left: 0;\n  right: unset;\n  left: unset;\n}\n\n.message-bubble-context-menu-wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.message-bubble-context-menu-wrapper, .message-bubble-reaction-button {\n  pointer-events: auto; /* Re-enable pointer events for buttons */\n  position: relative;\n}\n\n/* Portal container for context menus - created dynamically and attached to .messages-list */\n#message-context-menu-portal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Allow clicks through to messages */\n  z-index: 1000;\n  overflow: visible; /* Allow menu to extend beyond bounds */\n}\n\n.message-bubble-context-menu {\n  /* Layout */\n  padding: 0;\n  width: 166px;\n  \n  /* Appearance */\n  background-color: rgb(242, 242, 242);\n  opacity: 1;\n  box-shadow: rgb(0 0 0 / 4%) 0px 10px 20px, rgb(0 0 0 / 15%) 0px 6px 6px;\n  border-radius: 7px;\n  border: none;\n  \n  /* Typography */\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 14px;\n  \n  /* Positioning: Menu is rendered in a portal container (#message-context-menu-portal) \n     that scrolls with the messages. Position is absolute (relative to portal container)\n     with top/left coordinates set via inline styles. This ensures smooth scrolling\n     without jitter and proper z-index layering. */\n  position: absolute;\n  pointer-events: auto; /* Re-enable pointer events (portal container has pointer-events: none) */\n}\n\n/* Legacy menu position classes removed - all positioning now handled by inline styles in portal */\n\n.message-bubble-context-menu-item {\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n}\n\n.message-bubble-context-menu-item i {\n  width: 14px;\n  text-align: center;\n  margin-right: 10px;\n}\n\n.message-bubble-context-menu-item.first {\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px;\n}\n\n.message-bubble-context-menu-item.last {\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n}\n\n.message-bubble-context-menu-item:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.message-bubble-context-menu-item-text {\n  flex: 1;\n}\n\n.message-info {\n  box-sizing: border-box;\n  padding-top: 4px;\n  font-size: 12px;\n  line-height: 14px;\n  height: 20px;\n  font-family: Roboto, Arial, sans-serif;\n  color: rgba(0, 0, 0, 0.5);\n  overflow-wrap: break-word;\n  word-break: break-word;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.message-timestamp {\n  display: inline-block;\n  font-weight: bold;\n  margin-right: 0.3em;\n  vertical-align: middle;\n}\n\n.message-sender {\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: bold;\n  color: var(--netsfere-red);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 280px;\n}\n\n.fa.fa-check-circle.read {\n  color: var(--netsfere-red);\n}\n\n/* Message reply preview styles (inside message bubbles) */\n.message-bubble .message-reply-preview {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 8px;\n  padding: 4px 8px;\n  background-color: rgb(191, 40, 57);\n  border-radius: 8px;\n  border: none;\n  max-width: 100%;\n  text-align: left;\n}\n\n.message-bubble .message-reply-preview-content {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n}\n\n.message-bubble .message-reply-preview-sender {\n  font-size: 11px;\n  font-weight: bold;\n  color: white !important;\n  margin-bottom: 2px;\n  line-height: 13px;\n  text-align: left;\n}\n\n.message-bubble .message-reply-preview-text {\n  font-size: 12px;\n  line-height: 14px;\n  color: rgba(255, 255, 255, 0.9) !important;\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n.message-reply-preview.attachment {\n  gap: 8px;\n}\n\n.message-reply-preview-thumbnail {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.message-reply-preview-icon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n  flex-shrink: 0;\n  filter: brightness(0) invert(1);\n}\n\n/* Edit indicator styles */\n.edit-indicator {\n  font-size: 11px;\n  font-style: italic;\n  color: rgba(0, 0, 0, 0.6);\n  margin-left: 4px;\n  user-select: none;\n}\n\n.message-bubble.user .edit-indicator {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.edit-indicator.clickable {\n  cursor: pointer;\n}\n\n.edit-indicator.clickable:hover {\n  text-decoration: underline;\n}\n\n/* Reaction button styles */\n.message-bubble-reaction-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.message-bubble-reaction-button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.reaction-icon {\n  width: 15px;\n  height: 15px;\n  filter: grayscale(100%);\n  opacity: 0.7;\n  user-select: none;\n  object-fit: contain;\n  margin-left: 1px; /* Add small left margin to prevent left side cutoff */\n  margin-top: 1px; /* Add small top margin to lower the position slightly */\n}\n\n/* Emoji picker container for message reactions */\n.message-bubble-emoji-picker-container {\n  position: absolute;\n  right: 0px;\n  top: 5px;\n  z-index: 1001; /* Higher than other overlays */\n}\n\n/* Attachment message styles */\n.attachment-message {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.attachment-message--file {\n  cursor: pointer;\n}\n\n.attachment-file-details {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n\n.attachment-file-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.attachment-filename-inline {\n  font-weight: 500;\n  color: inherit;\n}\n\n.attachment-file-type-inline {\n  font-size: 12px;\n  opacity: 0.8;\n}\n\n.attachment-file-size-inline {\n  font-size: 12px;\n  opacity: 0.7;\n}\n\n/* Semantic button wrapper for attachment icon - accessible and keyboard navigable */\n.attachment-icon-btn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  line-height: 0; /* Remove extra spacing */\n}\n\n.attachment-icon-btn:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.attachment-icon-btn:focus-visible {\n  outline: 2px solid #007AFF;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.attachment-icon {\n  width: 60px;\n  height: 60px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n/* New styles for image/video previews */\n.attachment-preview-btn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  display: block;\n  position: relative;\n  line-height: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.attachment-preview {\n  max-width: 150px;\n  max-height: 100px;\n  width: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.attachment-preview-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 250px;\n  height: 150px;\n  background-color: #f0f0f0;\n  color: #888;\n  font-size: 12px;\n  font-style: italic;\n  text-align: center;\n  padding: 10px;\n  gap: 8px;\n}\n\n/* Make attachment icons white in user message bubbles */\n.message-bubble.user .attachment-icon {\n  filter: brightness(0) invert(1);\n}\n\n.attachment-info.preview-style {\n  color: var(--netsfere-red);\n  font-weight: 500;\n  font-size: 13px;\n}\n\n/* Clickable elements styling */\n.attachment-icon.clickable {\n  cursor: pointer;\n  transition: opacity 0.2s ease, transform 0.1s ease;\n  border-radius: 4px;\n}\n\n.attachment-icon.clickable:hover {\n  opacity: 0.8;\n  transform: scale(1.02);\n}\n\n.attachment-icon.clickable:active {\n  transform: scale(0.98);\n}\n\n.attachment-info.clickable {\n  cursor: pointer;\n  border-radius: 2px;\n  padding: 1px 2px;\n  margin: -1px -2px;\n  transition: background-color 0.2s ease;\n}\n\n.attachment-info.clickable:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n/* Hover effects for user messages */\n.message-bubble.user .attachment-info.clickable:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.attachment-info {\n  white-space: nowrap;\n  color: rgb(222, 72, 88);\n  line-height: 15px;\n  font-size: 13px;\n  text-decoration: none;\n}\n\n/* Attachment thumbnail styles */\n.attachment-thumbnail {\n  margin-bottom: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n  max-width: 200px;\n}\n\n.thumbnail-image {\n  width: 100%;\n  height: auto;\n  max-height: 150px;\n  object-fit: cover;\n  display: block;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.thumbnail-image:hover {\n  opacity: 0.9;\n}\n\n/* Download Progress Styles */\n.attachment-icon-wrapper {\n  position: relative;\n  width: 60px;\n  height: 60px;\n  flex-shrink: 0;\n}\n\n.download-progress-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 5;\n}\n\n/* Cancel download button - WCAG AA compliant (44x44px minimum) */\n.cancel-download-btn {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  min-width: 44px;\n  min-height: 44px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  color: #333;\n  font-weight: bold;\n  transition: all 0.2s ease;\n}\n\n.cancel-download-btn:hover {\n  background: white;\n  transform: scale(1.05);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.cancel-download-btn:active {\n  transform: scale(0.98);\n}\n\n.cancel-download-btn:focus-visible {\n  outline: 2px solid #ffffff;\n  outline-offset: -2px;\n}\n\n.attachment-icon.downloading {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.attachment-info.downloading {\n  opacity: 0.7;\n  cursor: default;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
